import { render, staticRenderFns } from "./HerbIdealTemplateModal.vue?vue&type=template&id=744502e0"
import script from "./HerbIdealTemplateModal.vue?vue&type=script&lang=js"
export * from "./HerbIdealTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports